import styles from "./theming-configuration-container.less";

type ThemingConfigurationContainerProps = {
    children: React.ReactNode | Array<React.ReactNode>;
};

export const ThemingConfigurationContainer = (props: ThemingConfigurationContainerProps) => {
    const { children } = props;

    return (
        <div className={styles.themingConfigurationContainer}>
            {children}
        </div>
    );
};